import React from 'react';
import styled, { css, keyframes } from 'styled-components';
var pulse = keyframes(["0%,60%,100%{opacity:1;transform:scale(1);}30%{opacity:0.1;transform:scale(0.01);}"]);
var pulseRule = css(["", " 1s ease infinite;"], pulse);
var getColor = function getColor(theme, color) {
  return color ? theme.colors[color] || color : theme.mainColor;
};
var Dot = styled.div.withConfig({
  displayName: "Spinner__Dot",
  componentId: "sc-1kpp0x8-0"
})(["display:inline-block;width:8px;height:8px;border-radius:100%;margin:2px;animation:", ";"], pulseRule);
var SpinnerStyled = styled.div.withConfig({
  displayName: "Spinner__SpinnerStyled",
  componentId: "sc-1kpp0x8-1"
})(["display:inline-block;position:relative;width:", ";height:18px;", "{background-color:", ";}& > div:nth-child(1){animation-delay:-200ms;}& > div:nth-child(2){animation-delay:-100ms;}& > div:nth-child(3){animation-delay:0ms;}"], function (_ref) {
  var width = _ref.width;
  return width;
}, Dot, function (_ref2) {
  var color = _ref2.color,
    theme = _ref2.theme;
  return getColor(theme, color);
});
export var Spinner = function Spinner(_ref3) {
  var color = _ref3.color,
    _ref3$width = _ref3.width,
    width = _ref3$width === void 0 ? '54px' : _ref3$width;
  return React.createElement(SpinnerStyled, {
    color: color,
    width: width
  }, React.createElement(Dot, null), React.createElement(Dot, null), React.createElement(Dot, null));
};